import { render, staticRenderFns } from "./btn-layout-preset.vue?vue&type=template&id=6a1e12de&scoped=true"
import script from "./btn-layout-preset.vue?vue&type=script&lang=js"
export * from "./btn-layout-preset.vue?vue&type=script&lang=js"
import style0 from "./btn-layout-preset.vue?vue&type=style&index=0&id=6a1e12de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1e12de",
  null
  
)

export default component.exports